
// ! rename the function to align with the widget name
export const collectionToplineMeta = async () => {
    const el = document.querySelector('.curious-collection-topline-meta');
    if (!el) return;

    // ------------------------------------------------------------

    const endpoint = el.getAttribute('data-endpoint');
    if (!endpoint) {
        console.error('No endpoint specified for the sonata-topline-meta widget');
        return;
    }
    const url = `${window.apiUri}${endpoint}`
    try {
        const response = await fetch(url)
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
        }
        const data = await response.json();

        console.log(data)
        
        const metaContainer = el.querySelector('.meta-container')
        const toplineMeta = [
            {
                key: 'Location',
                value: data.location, 
                show: (data.location !== '') && (data.location !== null),
            }, 
            {
                key: 'Type',
                value: data.type, 
                show: (data.type) && (data.type !== null),
            },
            {
                key: 'RISM',
                value: data.rism, 
                show: data.rism !== '' && (data.rism !== null),
            },
            {
                key: 'Short Title',
                value: data.short_title, 
                show: data.short_title !== '' && (data.short_title !== null),
            },
            {
                key: 'Holding Library',
                value: data.holding_library, 
                show: data.type === 'manuscript' && data.holding_library !== '' && (data.holding_library !== null),
            },
            {
                key: 'Editor / Publisher',
                value: data.editor_publisher, 
                show: data.type === 'printed-edition' && data.editor_publisher !== '' && (data.editor_publisher !== null),
            },
            {
                key: 'No. Sonatas',
                value: data.sonatas.length, 
                show: true,
            }
        ]

        const html = toplineMeta.map(item => {
            if(item.show) { 
                return `
                <div class="meta">
                    <strong>${item.key}: </strong>
                    <span>${item.value}</span>
                </div>
                `
            }
        }).join('')
        metaContainer.innerHTML = html;

        el.classList.remove('loading')


    } catch(error) {
        console.error(error.message)
    }

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

